<div class="cpcontent googlesignin" [hidden]="isAuthenticatedWithFirebase">
    <h5>Signin with Google to access the Firebase database</h5>
    <br>
    <div class="row">
        <div class="col-md-6">
            <button class="btn btn-primary" (click)="signInWithGoogle()">Sign in with Google</button>
        </div>
    </div>
</div>
<div class="cpcontent" [hidden]="!isAuthenticatedWithFirebase">
    <h1>Avatars in Firebase Database</h1>
    <div class="row">
        <div class="col-md-4">
            <table class="table table-bordered" style="max-width:500px">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Scale</th>
                        <th>SeqNo</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of avatars | keyvalue">
                        <td class="link" (click)="selectAvatar(item)">{{item.key}}</td>
                        <td>{{toAny(item.value).scale}}</td>
                        <td>{{toAny(item.value).seqNo}}</td>
                        <td><button class="btn btn-warning btn-sm" (click)=deleteAvatar(item.key)>Delete</button></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-md-4">
            <h5>Add a new Avatar</h5>
            <sa-input-text [(text)]="avatar.name" [title]="'name' "></sa-input-text>
            <sa-input-number [(text)]="avatar.scale" [title]="'Scale'"></sa-input-number>
            <sa-input-number [(text)]="avatar.seqNo" [title]="'Sequence'"></sa-input-number>
            <button class="btn btn-primary btn-sm" (click)="addAvatar()">Add</button> 
        </div>
    </div>

    <td></td>
    <td></td>

</div>
